<template>
  <div class="container fluid">
    <div class="row">
      <div class="page-content" id="lang" style="display: block;">
        <div style="background-color: #fff">
          <section class="container-fluid topPDF" style="padding: 20px 25px">
            <div style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 40px;
          ">
              <span style="margin: 10px 0 0px">
                <!-- <img src="../../public/dashboard-assets/images/M7/PLA_top.png" width="350" alt="no image" /> -->
                <h1 class="pmaps-color" style="
                  font-style: normal;
                  font-weight: 700;
                  font-size: 60px;
                  color:#7c68ee;
                  word-break: break-word;
                  background: none;
                ">
                  {{
                    this.basicInfo?.testName
                      ? this.basicInfo?.testName
                      : "NA"
                  }}
                </h1>
                <span style="
                border: 2px solid #7b68ee;
                width: 100%;
                display: block;
                margin: 15px 0;
              "></span>
                <h2 style="font-style: normal; font-weight: 500; font-size: 30.4979px">
                  {{
                    this.basicInfo?.companyName
                      ? this.basicInfo?.companyName
                      : "NA"
                  }}
                </h2>
              </span>
              <span>
                <img src="../../public/dashboard-assets/images/M7/Proctor-header-img.png" width="400" alt="" />
              </span>
            </div>
          </section>

          <section style="padding: 20px 25px">
            <h4 style="
            text-transform: uppercase;
            font-weight: 700;
            font-size: 24px;
            margin-bottom: 25px;
            font-style: normal;
            color: #7c68ee;
          ">
              language Report
            </h4>
            <div class="Recomended_icon_btn mb-2" v-if="this.recommendationValue">
              <div class="Assessment_Recommended_new" :class="getRecommendationClass()"
                style="display: flex;align-items: center;flex-wrap: wrap;flex-direction: row;">
                <img :src="this.recommendation_img" style="width:25px;height:25px;" alt="" />
                <p style="font-size: 20px;margin-left: 2px;  line-height: 1; padding-bottom: 0px; margin-bottom: 0;">
                  {{ this.recommendationValue }}</p>
              </div>
            </div>
            <!-- basic info -->
            <div style="margin-top: 25px">
              <span style="
              font-style: normal;
              font-weight: 700;
              font-size: 20px;
              letter-spacing: 0.008em;
              text-transform: uppercase;
              color: #666666;
            ">basic info</span>
              <p style="
              font-style: italic;
              font-weight: 400;
              font-size: 14px;
              padding-top: 15px;
              color: #666666;
            ">
                From the test results it seems that, the candidate may be considered
                for the further evaluation in the recruitment process.
              </p>
              <div class="row" style="
              border: 1px solid rgba(0, 0, 0, 0.17);
              border-radius: 8px;
              margin: 25px 0;
              padding: 15px;
            ">
                <div class="col-md-4" style="padding-bottom: 20px; flex: 0 0 auto; width: 33.33333333%">
                  <label style="font-weight: 400; font-size: 14px; color: #7b818d">Candidate Name</label>
                  <h6 style="font-weight: 800; font-size: 14px; color: #292e34">
                    {{ this.basicInfo.name ? this.basicInfo.name : "NA" }}
                  </h6>
                </div>
                <div class="col-md-4" style="padding-bottom: 20px; flex: 0 0 auto; width: 33.33333333%">
                  <label style="font-weight: 400; font-size: 14px; color: #7b818d">Candidate ID</label>
                  <h6 style="font-weight: 800; font-size: 14px; color: #292e34">
                    {{ this.candidateId ? this.candidateId : "NA" }}
                  </h6>
                </div>
                <div class="col-md-4" style="padding-bottom: 20px; flex: 0 0 auto; width: 33.33333333%">
                  <label style="font-weight: 400; font-size: 14px; color: #7b818d">Email</label>
                  <h6 style="font-weight: 800; font-size: 14px; color: #292e34">
                    {{
                      this.basicInfo?.emailAddress
                        ? this.basicInfo?.emailAddress
                        : "NA"
                    }}
                  </h6>
                </div>
                <div class="col-md-4" style="padding-bottom: 20px; flex: 0 0 auto; width: 33.33333333%">
                  <label style="font-weight: 400; font-size: 14px; color: #7b818d">Exam Started</label>
                  <h6 style="font-weight: 800; font-size: 14px; color: #292e34">
                    {{
                      this.basicInfo?.examStarted
                        ? this.basicInfo?.examStarted
                        : "NA"
                    }}
                  </h6>
                </div>
                <div class="col-md-4" style="padding-bottom: 20px; flex: 0 0 auto; width: 33.33333333%">
                  <label style="font-weight: 400; font-size: 14px; color: #7b818d">Invited By</label>
                  <h6 style="font-weight: 800; font-size: 14px; color: #292e34">
                    {{
                      this.basicInfo?.invitedBy ? this.basicInfo?.invitedBy : "NA"
                    }}
                  </h6>
                </div>
                <div class="col-md-4" style="padding-bottom: 20px; flex: 0 0 auto; width: 33.33333333%">
                  <label style="font-weight: 400; font-size: 14px; color: #7b818d">Test Name</label>
                  <h6 style="font-weight: 800; font-size: 14px; color: #292e34">
                    {{ this.basicInfo?.testName ? this.basicInfo?.testName : "NA" }}
                  </h6>
                </div>
                <div class="col-md-4" style="padding-bottom: 20px; flex: 0 0 auto; width: 33.33333333%">
                  <label style="font-weight: 400; font-size: 14px; color: #7b818d">Language</label>
                  <h6 style="font-weight: 800; font-size: 14px; color: #292e34">
                    {{ this.basicInfo?.language ? this.basicInfo?.language : "NA" }}
                  </h6>
                </div>
                <div class="col-md-4" style="padding-bottom: 20px; flex: 0 0 auto; width: 33.33333333%">
                  <label style="font-weight: 400; font-size: 14px; color: #7b818d">Time Taken (in min)</label>
                  <h6 style="font-weight: 800; font-size: 14px; color: #292e34">
                    {{
                      this.basicInfo?.timeTakenInMins
                        ? this.basicInfo?.timeTakenInMins
                        : "NA"
                    }}
                  </h6>
                </div>
                <div class="col-md-4" style="padding-bottom: 20px; flex: 0 0 auto; width: 33.33333333%">
                  <label style="font-weight: 400; font-size: 14px; color: #7b818d">Total Question Attempted</label>
                  <h6 style="font-weight: 800; font-size: 14px; color: #292e34">
                    {{
                      this.basicInfo?.totalQuestionAttempted
                        ? this.basicInfo?.totalQuestionAttempted
                        : "NA"
                    }}
                  </h6>
                </div>
              </div>
            </div>

            <div style="margin-top: 25px;page-break-before: always;">
              <span style="
                  font-style: normal;
                  font-weight: 700;
                  font-size: 20px;
                  letter-spacing: 0.008em;
                  color: #666666;
                  text-transform: uppercase;
                  letter-spacing: 0.008em;
                ">LANGUAGE SUMMARY</span>
              <p style="
                  font-style: italic;
                  font-weight: 400;
                  font-size: 16px;
                  color: #666666;
                  margin-bottom: 10px;
                ">
                Includes scores of various eva sections like written and spoken
                communication, comprehension and listening, and pronunciation.
              </p>
            </div>

            <div style="
                border: 1px solid rgba(0, 0, 0, 0.17);
                padding: 25px;
                border-radius: 10px;
                margin: 30px 0;
              ">
              <div class="row border-bottom pb-5 mb-4">
                <div class="col-3" v-for="item in this.languageSummary" :key="item">
                  <label style="font-weight: 400; font-size: 14px; color: #7b818d">{{ item.parameterName }}</label>
                  <h6 style="font-weight: 500; font-size: 14px; color: #292e34">
                    {{ item.tabsoluteScore ? item.tabsoluteScore + "%" : "NA" }}
                  </h6>
                </div>
              </div>

              <div style="margin-top: 50px">
                <span style="
                    padding: 6px 20px;
                    background-color: #f1f0ff;
                    border-radius: 8px;
                    margin: 30px 0 15px;
                  ">
                  Definitions
                </span>
                <div class="row my-4" v-for="item in this.languageSummary" :key="item">
                  <div class="col-2" style="
                      color: #7b818d;
                      flex: 0 0 auto;
                      font-weight: 500;
                      width: 16.66666667%;
                    ">
                    {{ item.parameterName }}
                  </div>
                  <div class="col-1 text-end">-</div>
                  <div class="col-8" style="flex: 0 0 auto; width: 66.66666667%">
                    <p style="color: #666666; font-weight: 400">
                      {{ item.definition ? item.definition : "NA" }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="my-4 before">
              <div class="BG_linear_Gradient" style="
                border-radius: 8px;
                padding: 16px;
                color: #fafbfd;
                font-weight: 700;
                font-size: 20px;page-break-before: always;
              ">
                eVA<sup>TM</sup> Fitment
              </div>
              <div style="margin: 30px 0">
                <span style="
                  background: #f1f0ff;
                  font-weight: 500;
                  border-radius: 4px;
                  padding: 6px 12px;
                  color: #292e34;
                  width: auto;
                ">Definitions</span>
                <p style="
                  margin-top: 10px;
                  font-style: italic;
                  font-weight: 400;
                  font-size: 16px;
                  color: #292e34;
                ">
                  {{
                    this.languageReport.definition
                      ? this.languageReport.definition
                      : "NA"
                  }}
                </p>
              </div>
              <div class="row align-items-center">
                <div class="col-10" style="flex: 0 0 auto; width: 80%">
                  <span style="
                    background: #f1f0ff;
                    font-weight: 500;
                    border-radius: 4px;
                    padding: 6px 12px;
                    color: #292e34;
                    width: auto;
                  ">Score Description</span>
                  <div class="d-flex" style="margin: 10px 0">
                    <div style="display: flex; align-items: center" v-for="item in this.score1.ranges" :key="item">
                      <div style="
                        width: 15px;
                        height: 15px;
                        border-radius: 50%;
                        /* content: ; */
                        padding-right: 10px;
                      " :style="{ background: item.colorCode }"></div>
                      <div class="mx-2">
                        {{ item.rangeName }} ({{ item.minVal }}-{{ item.maxVal }})
                      </div>
                    </div>
                  </div>
                  <p style="font-weight: 400; font-size: 16px; color: #292e34">
                    {{
                      this.languageReport.comment
                        ? this.languageReport.comment
                        : "NA"
                    }}
                  </p>
                </div>
                <div class="col-2" style="flex: 0 0 auto; width: 20%">
                  <CustomChartVue :score="this.score1" v-if="this.show1" :main="this.customName"
                    :iconcolor="'transform-328deg'" />
                </div>
              </div>
            </div>

            <div style="margin-top: 25px;page-break-after: always;">
              <span style="
                font-style: normal;
                font-weight: 700;
                font-size: 20px;
                letter-spacing: 0.008em;
                color: #666666;
                text-transform: uppercase;
                letter-spacing: 0.008em;
              ">eVA<sup>TM</sup> Summary</span>
              <p style="
                font-style: italic;
                font-weight: 400;
                font-size: 16px;
                color: #666666;
                margin-bottom: 10px;
              ">
                refers to the combination of all the scores obtained by the
                candidate on the eva parameters.
              </p>

              <div style="
                border: 1px solid rgba(0, 0, 0, 0.17);
                padding: 15px;
                border-radius: 8px;
                margin-top: 15px;
              ">
                <div class="row justify-content-center mx-3">
                  <div class="col-4 my-3 text-center" v-for="(param, index) in this.languageReport.parameters"
                    :key="index" :class="{
                      'border-end':
                        ((index + 1) % 2 == 0 || index == 0) &&
                        this.languageReport.parameters.length > 1,
                    }">
                    <label style="color: #292e34; font-weight: 500">{{ param.parameterName }} </label><br />
                    <CustomChartVue :score="this.score[index]" v-if="this.show[index]"
                      :main="param.parameterName + 'pdf'" :iconcolor="'transform-328deg'" />
                  </div>
                </div>
              </div>
            </div>

            <div style="
              border: 1px solid rgba(0, 0, 0, 0.17);
              padding: 25px;
              border-radius: 10px;
              margin: 30px 0;page-break-inside: avoid;
            ">
              <div>
                <span style="
                  padding: 6px 20px;
                  background-color: #f1f0ff;
                  border-radius: 8px;
                  margin: 30px 0 15px;
                ">
                  Definitions
                </span>
                <div class="row my-4" v-for="(item, index) in this.languageReport.parameters" :key="index">
                  <div class="col-2" style="color: #7b818d">
                    {{ item.parameterName }}
                  </div>
                  <div class="col-1 text-end">-</div>
                  <div class="col-8">
                    <div class="d-flex">
                      <div style="display: flex; align-items: center" v-for="item in this.score[index].ranges"
                        :key="item">
                        <div style="
                          width: 15px;
                          height: 15px;
                          border-radius: 50%;
                          /* content: ; */
                          padding-right: 10px;
                        " :style="{ background: item.colorCode }"></div>
                        <div class="mx-2">
                          {{ item.rangeName }} ({{ item.minVal }}-{{ item.maxVal }})
                        </div>
                      </div>
                    </div>
                    <p style="color: #666666">
                      {{ item.definition ? item.definition : "NA" }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div style="margin-top: 50px;page-break-before: always;">
              <div>
                <span style="
                font-style: normal;
                font-weight: 700;
                font-size: 20px;
                letter-spacing: 0.008em;
                color: #666666;
                text-transform: uppercase;
                letter-spacing: 0.008em;
              ">eVA<sup>TM</sup> Detailed language report</span>
                <p style="
                font-style: italic;
                font-weight: 400;
                font-size: 16px;
                color: #666666;
                margin-bottom: 10px;
              ">
                  Includes a summary of scores for different language skills, such as
                  reading, writing, speaking, and listening.
                </p>
              </div>
              <div v-for="(item, index) in this.languageReport.parameters" :key="index">
                <div style="margin: 20px 0 50px;page-break-inside: avoid;">
                  <div class="BG_linear_Gradient" style="
                  border-radius: 8px;
                  padding: 16px;
                  color: #fafbfd;
                  font-weight: 700;
                  font-size: 20px;
                ">
                    {{ item.parameterName }}
                  </div>
                  <div style="margin: 30px 0">
                    <span style="
                    background: #f1f0ff;
                    font-weight: 500;
                    border-radius: 4px;
                    padding: 6px 12px;
                    color: #292e34;
                    width: auto;
                  ">Definitions</span>
                    <p style="
                    margin-top: 10px;
                    font-style: italic;
                    font-weight: 400;
                    font-size: 16px;
                    color: #292e34;
                  ">
                      {{ item.definition }}
                    </p>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-10" style="flex: 0 0 auto; width: 70%">
                      <span style="
                      background: #f1f0ff;
                      font-weight: 500;
                      border-radius: 4px;
                      padding: 6px 12px;
                      color: #292e34;
                      width: auto;
                    ">Score Description</span>
                      <div class="d-flex" style="margin: 10px 0;">
                        <div style="display: flex; align-items: center" v-for="sub in this.score[idx]" :key="sub">
                          <div style="
                          width: 15px;
                          height: 15px;
                          border-radius: 50%;
                          /* content: ; */
                          padding-right: 10px;
                        " :style="{ background: sub.colorCode }"></div>
                          <div class="mx-2">
                            {{ sub.rangeName }} ({{ sub.minVal }}-{{ sub.maxVal }})
                          </div>
                        </div>
                      </div>
                      <p style="font-weight: 400; font-size: 16px; color: #292e34">
                        {{ item.comment }}
                      </p>
                    </div>
                    <div class="col-2" style="flex: 0 0 auto; width: 30%">
                      <CustomChartVue :score="this.score[index]" v-if="this.show[index]"
                        :main="item.parameterName + item.parameterId + 'pdf'" :iconcolor="'transform-328deg'" />
                    </div>
                  </div>
                </div>
                <div v-if="item.subParameters.length > 0">
                  <div class="row my-4"
                    style="border: 1px solid rgba(0, 0, 0, 0.17); border-radius: 5px;page-break-inside: avoid;"
                    v-for="(param, index) in item.subParameters" :key="index">
                    <div class="col-md-4 col-4" style="background-color: #f9fafd; border-radius: 5px 0 0 5px">
                      <div class="p-4">
                        <h3 style="color: #666">{{ item.parameterName }}</h3>
                        <ul style="list-style-type: none">
                          <li class="my-4" style="word-wrap: break-word" :style="{
                            color: index == idx ? '#7c68ee' : '',
                            'font-weight': index == idx ? 700 : '',
                          }" v-for="(sub, idx) in item.subParameters" :key="idx">
                            {{ sub.parameterName }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-md-8 col-8">
                      <div class="p-4">
                        <h2>{{ param.parameterName }}</h2>
                        <div style="margin: 20px 0 50px">
                          <div style="margin: 30px 0">
                            <span style="
                            background: #f1f0ff;
                            font-weight: 500;
                            border-radius: 4px;
                            padding: 6px 12px;
                            color: #292e34;
                            width: auto;
                          ">Definitions</span>
                            <p style="
                            margin-top: 10px;
                            font-style: italic;
                            font-weight: 400;
                            font-size: 16px;
                            color: #292e34;
                          ">
                              {{ param.definition ? param.definition : "NA" }}
                            </p>
                          </div>
                          <div class="row align-items-center">
                            <div class="col-10" style="flex: 0 0 auto; width: 67%">
                              <span style="
                              background: #f1f0ff;
                              font-weight: 500;
                              border-radius: 4px;
                              padding: 6px 12px;
                              color: #292e34;
                              width: auto;
                            ">Score Description</span>
                              <div class="d-flex" style="margin: 10px 0;width: 500px;">
                                <div style="display: flex; align-items: center"
                                  v-for="subItem in param.scoreMain?.ranges" :key="subItem">
                                  <div style="
                                  width: 15px;
                                  height: 15px;
                                  border-radius: 50%;
                                  background-color: #fd71ae;
                                  /* content: ; */
                                  padding-right: 10px;
                                " :style="{ background: subItem.colorCode }"></div>
                                  <div class="mx-2">
                                    {{ subItem.rangeName }} ({{ subItem.minVal }}-{{
                                      subItem.maxVal
                                    }})
                                  </div>
                                </div>
                              </div>
                              <p style="
                              font-weight: 400;
                              font-size: 16px;
                              color: #292e34;
                            ">
                                {{ param.comment ? param.comment : "NA" }}
                              </p>
                            </div>
                            <div class="col-2" style="flex: 0 0 auto; width: 33%">
                              <CustomChartVue :score="param.scoreMain" v-if="param.show"
                                :main="param.parameterName + 'pdf'" :iconcolor="'transform-328deg'" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- new code for typing -->


            <!-- end code  -->
            <!-- Screenshots -->

            <Disclaimer></Disclaimer>
          </section>

          <!-- <section class="container-fluid footerPDF" style="padding: 20px 25px">
        <span style="
              font-weight: 400;
              font-size: 16px;
              color: #292e34;
              font-style: italic;
            ">Language |<span style="font-weight: 500"> 5</span>
        </span>
      </section> -->

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { momentDateFormat } from "../utils";
import CustomChartVue from "./CustomChart.vue";
import store from "../store";
//import CodeEditor from 'simple-code-editor';
import html2canvas from "html2canvas";
import Disclaimer from "./report/partial-view/Disclaimer.vue";
import Base64Images from "../utils/base64Image.js";
import * as html2pdf from "html2pdf.js";
import { SetClarityData } from "../platformFeatures/featureUtils.js";
export default {
  name: "ActiveTestReportLanguagePDF",
  // props: ['testId', 'candidateId', 'name',],

  data() {
    return {
      languageSummary: "",
      languageReport: "",
      basicInfo: "",
      // candidateId: 10098,
      candidateId: window.atob(this.$route.query.candidateId),
      candidateName: "",
      // testId: 3658 ,//this.$route.query.testId
      /*score data*/
      score1: {},
      show1: false,
      show: [],
      score: [],
      subShow: [],
      subScore: [],
      typingApi: [],
      codingTabs: [],
      customName: "score1pdf",
      imgDataCodeing: '',
      recommendationValue: "",
      color_recommendation: '',
      recommendation_img: "",
      namePdf: "",
      testNamePDF: "",
      Companylogo: "",
    };
  },
  components: {
    CustomChartVue,
    Disclaimer,
    // CodeEditor
  },
  async created() {
    await this.getInfo();
    await this.summaryData();
    await this.reportData();
    await this.GetScoreRank();
    await this.callPDfFunction();
  },
  async mounted() {

    SetClarityData();

    //store.state.loader.isLoading = true;
    // await this.getInfo();
    // await this.summaryData();
    // await this.reportData();
    // await this.GetScoreRank();
    //this.typingTab();
    //this.codingTab();


    // this.callPDfFunction(); 


  },
  methods: {
    ...mapActions([
      "getLanguageSummary",
      "getTyping",
      "getLanguageReport",
      "getBasicInfo",
      "getCoding",
      "GetScoreRankData"
    ]),
    momentDateFormat,

    async getInfo() {
      var info = await this.getBasicInfo(this.candidateId);

      if (info?.status) {
        this.basicInfo = info.object.data;
        this.Companylogo = this.basicInfo.companyLogo;
        this.namePdf = this.basicInfo.name;
        this.testNamePDF = this.basicInfo.testName;
      } else {
        this.basicInfo = null;
      }
      this.basicInfo.examStarted = this.momentDateFormat(
        this.basicInfo.examStarted
      );
    },
    async summaryData() {
      var summary = await this.getLanguageSummary(this.candidateId);
      this.languageSummary = summary.object.data;
    },
    async reportData() {
      var report = await this.getLanguageReport(this.candidateId);
      this.languageReport = report.object.data;

      /*main score chart*/
      var score = {
        marksScored: this.languageReport.score,
        outOfMarks:
          this.languageReport.ranges[this.languageReport.ranges.length - 1]
            .maxVal,
        result: this.languageReport.rangeText,
        ranges: this.languageReport.ranges,
      };
      this.score1 = score;
      this.show1 = true;
      /*main score chart*/

      this.languageReport.parameters.forEach((element, index) => {
        /*parameter score chart */
        this.show[index] = false;
        var score = {
          marksScored: element.score,
          outOfMarks: element?.ranges[element?.ranges.length - 1].maxVal,
          result: element.fitment,
          ranges: element.ranges,
        };
        this.score[index] = score;
        this.show[index] = true;
        /*parameter score chart */
        if (element.subParameters.length > 0) {
          element.subParameters.forEach((elm) => {
            elm.show = false;
            var subScore = {
              marksScored: elm.score,
              outOfMarks: elm?.ranges[elm?.ranges.length - 1].maxVal,
              result: elm.fitment,
              ranges: elm.ranges,
            };
            elm.scoreMain = subScore;
            elm.show = true;
          });
        }
      });
    },

    /* customChart(chartData, result, index, idx) {
        var subscore = {
          marksScored: 0,
          outOfMarks: 10,
          result: result,
          ranges: chartData,
        };
        this.subScore[index] = subscore;
        this.subShow[index] = true;
    }*/

    async codingTab() {
      const response = await this.getCoding(9884);
      this.codingTabs = response.object.data.sections;
      // this.codingTabs.forEach((elm, index) => {
      //   if (index == 0) {
      //     elm.show = true;
      //   } else {
      //     elm.show = false;
      //   }
      // });
      setTimeout(async () => {
        const canvas = document.getElementById("CodeEditorimg");
        const scale = 6;
        this.imgDataCodeing = (await html2canvas(canvas, { scale })).toDataURL("image/png");
      }, 100);
    },
    async typingTab() {
      const response = await this.getTyping(10104);
      this.typingApi = response?.object?.data?.sections;
      // this.typingApi.questions.forEach((elm, idx) => {
      //   elm.show = false;
      //   if (idx == 0) {
      //     elm.show = true;
      //   }
      // });
    },

    async GetScoreRank() {
      var Rank = await this.GetScoreRankData(this.candidateId);
      this.recommendationValue = Rank?.object?.data?.testRecommendation;
    },

    getRecommendationClass() {
      if (this.recommendationValue === "This Assessment is Recommended.") {
        this.recommendation_img = "data:image/png;base64,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";
        return "recommended";
      } else if (this.recommendationValue === "This Assessment is not Recommended.") {
        this.recommendation_img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAYGSURBVHgBzVdNaFxVFD733vfeZOLUTpKKtqR2IgZUsEm6srgwQXDRVd24tV25UJopCEUQEwSpy7QoCl206saFQhTEhYuJFEUEaURtq6Kd1NBfp52kybyZ9+6P5573M5nMJJO40Qtv3n1/9/vOd75z7x2A/7gx+Bdt8cT5EcmdGc75OBcCBOdzONTR3dNjZdhm47DNtnDi20nJ3TlG4ByQBGD/GeGKPysnf5qCbbZNFbj0ylfjwvVGmIA+zsVOxthhPBc4ZxYULAHBBdjrmIi9LgshZrnDq4bBEt6Yy708NL9tApcmS2dx3CMEFIPxpM+FYZwxEd+PgW3fxO8wTI2JiTJH8Bnx0uDxTjgdU3DpWGmKIXgTDAGYMAhiWshYELHuHgIyUiRSRSApYKxozlyf3jIBBJ9EYGCC5MUIBEWJejHZCKFxz2eNZR/8pVVWX/ZZWA9BBRKMtlwtKJFmiWKYOvvsWEestuiLpXH8tCREHL2IpFahhmC1Dr3DfZA/uBt6hneC05ehb+QNH9StBqg/VsGU6+B6LqAHiIgNxxgNWmloaDm23g/OegIOF6MQy0dq4rmx0gCeE7B3chSyw/m2KJyHsnTA/jyYZQnq89vAfRNFjg3BmdYoj9aH8fX5DRXA6Auu65bwwwLlG6MPagGIAQ8ePn4AeG8b384t0GC+uEOqIIBRSjGFChitq4EfjPW99ng5eZV3BBcRuGxIYL18e+C2eZj3Q/2gMhrCIGRWfq0UIJE8Ipaun7xQaCFA4GJN5Cwyj/QD2LsF8HDmKsiPrrXezKAHnt0F/opvgSkVaESDnYJr3NKV6Qv5lABGPoVmK0STCaYOo7euvm//LnAHeqBbM3cCUN8ttd139maB7faggeZFBawPiAz2Cz2giykB9NpoUjKCSg9dLzXsGH1gc2Bfg/zkJphKCHww0/Ed78k8BHUkiGlQUiIJA3jYwniRSNoftHqer5nVktrNDO7YGPxOiNIvEDiNMdgD5vda9HDABdbvRgSGctCo+eD1ehCBWwU0s4ZMCWDNzyJwsTnVcioPb09vCqh+vAfq05sgDu0ChlVhc56A03NMQZIGhgS8Nx+N0tCfSRWwpUglqcgO82kK8OEpkp9Hc7mdPoUjWiLWpbsE2Am8TZ11zyT6Kc49+QBVYA5zplMCQ28fLAtGKrBkAXE9D1Q1aA666AMfRkV8tSk4tWyTfOOvezS3GwK25UjVcG7PWwcWUgLUccVntKDEi4vwBMirtSYBNBydawq6NT6SS/urZUyLMTG4rQLJwlB9nb679kNKAaNFxNj5PPylWVo2r9Z4NgXdmjMxkPar318HN+sSuCWB0eNgyGg9AZyACukKhqVoU2CuBaAX69GLOCh5AOW1BnOL+0A8tTN1ewpuTRqXZHC7Bss/3IBMLhulwCqAVaDCsJC+nzLhazccdknHcwbTUKqA98IejKqPjrWKkCc2aKoWwq9T56G3P5fIbyvAEmF4xdoUwKjvtpQhHg5WAvcxhV9WMBwDW20W/PIb58FRgqJP5LfuV3gGxa+0EdDC/QBBq3ZbxVgyGSEJNKW5HULw8TVaaru1lYsVuPhqCWBJQjafSyI3kfzkgTKoemrCluU4OL04ooWaRTPadYF2NeRgPGSAO6Ea+gFncXc4B86DWXDjiSr8uw4rlytQKV2FpZ9vwf0P9kUzH0WuIAHHEqwGoZoYO/PcfEcCtvnvXSm44Not9xQaYZ+SzUXEOrjh15FIA0JcKetISIYh3UexsJQdyOzAxcvYTYAxaLho4lGqitczdW/51NjM89W1eJtuy+X7i2dxgCPpFJquZklJadpsJJHSpiMBRtmxA9LoD+scimMzE9VOGF3/GdXfKV9AsBFSwgLQFiva4ZC8iKOlPWsCjcGRCPaNXnjs9MTQZuN3/WckQ3M0Wr2i2Yy2V7qZWx1dR+roRA3sG8085Y13G78rgdzxoXkM8jACl3U6nxO4vT6H/Vltn8nI6WnOZXj0kXefXug2/pb/nN7FLZQSYjw0Kt/DM6W+159oGfy34jejBoKCwkptODC3Uc7/d+0fzHSdONNjjSQAAAAASUVORK5CYII=";
        return "recommended_not";
      } else if (this.recommendationValue === "") {
        this.recommendation_img = "data:image/png;base64,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";
        return "recommended_null";
      } else {
        this.recommendation_img = "data:image/png;base64,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";
        return "recommended_default";
      }

    },

    async callPDfFunction() {
      store.state.loader.isLoading = true;
      const namePdf = this.namePdf;
      const testName = this.testNamePDF;
      // const Companylogo = this.Companylogo;
      // const clientCompany = this.clientCompany;
      var opt = {
        margin: [23, 1, 20, 1],
        filename: `Skills_${namePdf}`,
        html2canvas: { scale: 3, dpi: 192, letterRendering: true, useCORS: true },
        pagebreak: { mode: "css" },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      };
      /*header*/
      const headerContent = `
      <section class="container-fluid" style="padding: 15px 20px; background: linear-gradient(132deg, #F2F5F0 37.25%, #E8F7FF 85.4%); margin-botton:10px">
      <div style="display: flex; justify-content: space-between">
        <span>
          <img src="`+ Base64Images.PMapsLogo + `" alt="" />
        </span>
        <span style="font-size: 18px;
        font-weight: 500; padding: 10px 15px;">`+ testName + `
        </span>
        <span>
          <img src="`+ Base64Images.PMapsLogo2 + `" alt="" />
        </span>
      </div>
    </section>`;

      const headerContent1 = `
      <section class="container-fluid topPDF" style="padding: 20px 25px;">
      <div style="display: flex; justify-content: space-between">
        <span>
          <img src="`+ Base64Images.PMapsLogo + `" alt="" />
        </span>
        <span>
          <img src="`+ Base64Images.PMapsLogo2 + `" alt="" />
        </span>
      </div>
      </section>`;

      /*footer*/
      const footerContent = `<section class="container-fluid footerPDF" style="padding: 20px 25px"></span></section>`;

      html2pdf()
        .from(headerContent1)
        .toImg()
        .get("img")
        .then((image) => {
          html2pdf()
            .from(headerContent)
            .toImg()
            .get("img")
            .then((img) => {
              html2pdf()
                .from(footerContent)
                .toImg()
                .get("img")
                .then((ig) => {
                  html2pdf()
                    .from(document.getElementById("lang"))
                    .set(opt)
                    .toPdf()
                    .get("pdf")
                    .then((pdf) => {
                      var totalPages = pdf.internal.getNumberOfPages();
                      for (var i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        if (i != 1) {
                          pdf.addImage(
                            img,
                            "JPEG",
                            0,
                            0,
                            pdf.internal.pageSize.getWidth(),
                            0
                          );
                        } else {
                          pdf.addImage(
                            image,
                            "JPEG",
                            0,
                            0,
                            pdf.internal.pageSize.getWidth(),
                            0
                          );
                        }
                        pdf.addImage(
                          ig,
                          "JPEG",
                          0,
                          pdf.internal.pageSize.getHeight() - 23,
                          pdf.internal.pageSize.getWidth(),
                          0
                        );
                        pdf.setFontSize(15);
                        pdf.setTextColor(100);
                        pdf.text(
                          "Language " + "|" + i,
                          pdf.internal.pageSize.getWidth() - 35,
                          pdf.internal.pageSize.getHeight() - 3
                        );
                        this.$router.push({
                          name: "ActiveTestReportLanguage",
                          params: {
                            candidateId: this.$route.query.candidateId,
                            testId: this.$route.query.testId,

                          },
                          query: {
                            name: this.$route.query.name,
                            clientId: this.$route.query.clientId,
                            isParent: this.$route.query.isParent,
                            id: this.$route.query.id,
                            offset: this.$route.query.offset,
                            current: this.$route.query.current,
                          },
                        });

                        store.state.loader.isLoading = false;

                      }
                    })
                    .save();

                  //window.open('', '_self', ''); window.close();
                });
            });

        });

    },
  },
};
</script>

<style>
.donut-chart {
  position: relative;
  width: 130px;
  height: 130px;
  margin: 0 auto;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.recorte {
  border-radius: 50%;
  clip: rect(0px, 200px, 200px, 66px);
  height: 100%;
  position: absolute;
  width: 100%;
}

.quesito {
  border-radius: 50%;
  clip: rect(0px, 65px, 200px, 0px);
  height: 100%;
  position: absolute;
  width: 100%;
  font-family: monospace;
  font-size: 1.5rem;
}

#porcion1 {
  transform: rotate(0deg);
}

#porcion1 .quesito {
  background-color: #fd71ae;
  transform: rotate(90deg);
}

#porcion2 {
  transform: rotate(90deg);
}

#porcion2 .quesito {
  background-color: #ffc801;
  transform: rotate(88deg);
}

#porcion3 {
  transform: rotate(90deg);
}

#porcion3 .quesito {
  background-color: #49ccfa;
  transform: rotate(270deg);
}

#porcionFin {
  transform: rotate(180deg);
}

#porcionFin .quesito {
  background-color: #7c68ee;
  transform: rotate(270deg);
}

.circle_arrow {
  border-radius: 50%;
  z-index: 9;
  position: relative;
  transform: rotate(315deg);
}

.circle_arrow img {
  width: 90px;
  margin-top: -6px;
  fill: #df0000;
}

.circle_arrow img path {
  fill: #df0000;
}

p.center-date {
  background: #fff;
  position: absolute;
  text-align: center;
  font-size: 28px;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 110px;
  height: 110px;
  margin: auto;
  border-radius: 50%;
  line-height: 1.2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 16px;
  font-weight: 700;
  color: #7c68ee;
  z-index: 2;
}

p.center-date span {
  font-weight: normal;
  font-size: 12px;
}

.CodeEditor-kj {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.wrap_code>.code_area>textarea,
.wrap_code>.code_area>pre>code {
  white-space: pre-wrap;
  word-wrap: break-word;
  font-size: 4px !important;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 0px !important;
}

.code_editor>.code_area>pre {
  position: relative;
  margin: 0 !important;
  padding: 5px !important;
  font-size: 5px !important;
}

.code_editor {
  border-radius: 3px !important;
}
</style>
